import axios from 'axios'
import $router from '../router';
import indexBD from '../serviceBDLocal/indexBD';
const urlServive = 'https://registroapi.aplicacionesincontacto.com';
// const urlServive = 'http://localhost:3000';
// const urlServive = "https://registronuevobackup-7a36794aa0a3.herokuapp.com";
// const urlServive = "https://registroincontactoexpo-5e57c146e33f.herokuapp.com";

const login = (data) => {
    return new Promise((resolve, reject) => {
        axios
            .post(urlServive + '/user/login',
                {
                    username: data.username,
                    password: data.password,
                    browser: getBrowser(),
                    os: getSystemOperativo(),
                    eventId: data.eventId,
                    recaptcha_token: data.recaptcha_token
                })
            .then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
    })
}

const getInformationEvent = () => {
    return new Promise(async (resolve, reject) => {
        const db = await indexBD.getDb()
        const users = await indexBD.getUsers(db)
        const eventSelected = await indexBD.getEventSelecteds(db)
        const token = users[0].token;
        const event = eventSelected[0].event;
        axios
            .get(urlServive + '/event/' + event._id + '/information/basic',
                {
                    headers: {
                        Authorization: token
                    }
                }
            )
            .then(response => {
                resolve(response)
            }).catch(error => {
                verificationError(error)
                reject(error)
            })
    });
}


const getUserEvents = (username) => {
    return new Promise((resolve, reject) => {
        axios
            .get(urlServive + '/user/' + username + "/" + diff_to_GMT())
            .then(response => {
                resolve(response)
            }).catch(error => {
                verificationError(error);
                reject(error)
            })

    })
}

const closeAllSessionNotEvent = (userId) => {
    return new Promise((resolve, reject) => {
        axios
            .get(urlServive + '/sessions/close/all/user/' + userId)
            .then(response => {
                resolve(response)
            }).catch(error => {
                verificationError(error);
                reject(error)
            })

    })
}


const getEvents = () => {
    return new Promise(async (resolve, reject) => {
        const db = await indexBD.getDb()
        const users = await indexBD.getUsers(db)
        let token = users[0].token;
        axios
            .get(urlServive + '/exhibitor/events/users/' + diff_to_GMT(),
                {
                    headers: {
                        Authorization: token
                    }
                })
            .then(response => {
                resolve(response)
            }).catch(error => {
                verificationError(error);
                reject(error)
            })

    })
}

const syncPerson = (eventId, dataSync) => {
    return new Promise(async (resolve, reject) => {
        const db = await indexBD.getDb()
        const users = await indexBD.getUsers(db)
        let token = users[0].token;
        axios
            .post(urlServive + '/exhibitor/user/event/' + eventId + '/asyn/leads',
                dataSync,
                {
                    headers: {
                        Authorization: token
                    }
                })
            .then(response => {
                resolve(response)
            }).catch(error => {
                verificationError(error);
                reject(error)
            })

    });
}

const signatureOnly = (eventId, assistantId, file) => {
    return new Promise(async (resolve, reject) => {
        let formData = new FormData();
        formData.append('file', file);
        formData.append('autoRegisterWeb', "true");
        const db = await indexBD.getDb()
        const users = await indexBD.getUsers(db)
        let token = users[0].token;
        axios.post(urlServive + `/file/assistant/${assistantId}/event/${eventId}/signature`,
                formData,
                {
                    headers: {
                        Authorization: token
                    }
                })
            .then(response => {
                resolve(response)
            }).catch(error => {
                verificationError(error);
                reject(error)
            })

    });
}



const reportError = (eventId, dataSync, message) => {
    return new Promise(async (resolve, reject) => {
        const db = await indexBD.getDb()
        const users = await indexBD.getUsers(db)
        let token = users[0].token;
        axios
            .post(urlServive + '/exhibitor/user/event/' + eventId + '/reporterror/leads',
                {
                    dataSync,
                    message
                },
                {
                    headers: {
                        Authorization: token
                    }
                })
            .then(response => {
                resolve(response)
            }).catch(error => {
                verificationError(error);
                reject(error)
            })

    });
}

const diff_to_GMT = () => {
    let now = new Date();
    return -(now.getTimezoneOffset()) / 60;
}

const getBrowser = () => {
    var ua = navigator.userAgent, tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return 'IE ' + (tem[1] || '');
    }
    if (M[1] === 'Chrome') {
        tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
        if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M.join(' ');
}
const getSystemOperativo = () => {
    var OSName = "Desconocido";
    if (navigator.appVersion.indexOf("Win") != -1) OSName = "Windows";
    if (navigator.appVersion.indexOf("Mac") != -1) OSName = "MacOS";
    if (navigator.appVersion.indexOf("X11") != -1) OSName = "UNIX";
    if (navigator.appVersion.indexOf("Linux") != -1) OSName = "Linux";
    if (navigator.appVersion.indexOf("Android") != -1) OSName = "Android";

    return OSName;
}

const getAvaliablesZones = () => {
    return new Promise(async (resolve, reject) => {
        const db = await indexBD.getDb()
        const users = await indexBD.getUsers(db)
        const eventSelected = await indexBD.getEventSelecteds(db)
        let token = users[0].token;
        let event = eventSelected[0].event;
        axios
            .get(urlServive + '/zone/zones/event/' + event._id,
                {
                    headers: {
                        Authorization: token
                    }
                })
            .then(response => {
                resolve(response)
            }).catch(error => {
                verificationError(error);
                reject(error)
            })
    })

}

const getScreen = () => {
    return new Promise(async (resolve, reject) => {
        const db = await indexBD.getDb()
        const users = await indexBD.getUsers(db)
        const eventSelected = await indexBD.getEventSelecteds(db)
        let token = users[0].token;
        let event = eventSelected[0].event;
        axios
            .get(urlServive + '/event/' + event._id + "/screen",
                {
                    headers: {
                        Authorization: token
                    }
                })
            .then(response => {
                resolve(response)
            }).catch(error => {
                verificationError(error);
                reject(error)
            })
    })

}

const allFieldsPublic = () => {
    return new Promise(async (resolve, reject) => {
        const db = await indexBD.getDb()
        const users = await indexBD.getUsers(db)
        const eventSelected = await indexBD.getEventSelecteds(db)
        let token = users[0].token;
        let event = eventSelected[0].event;
        axios
            .get(urlServive + '/event/' + event._id + "/all/field/public",
                {
                    headers: {
                        Authorization: token
                    }
                })
            .then(response => {
                resolve(response)
            }).catch(error => {
                verificationError(error);
                reject(error)
            })
    });
}

const allFields = () => {
    return new Promise(async (resolve, reject) => {
        const db = await indexBD.getDb()
        const users = await indexBD.getUsers(db)
        const eventSelected = await indexBD.getEventSelecteds(db)
        let token = users[0].token;
        let event = eventSelected[0].event;
        axios
            .get(urlServive + '/event/' + event._id + "/all/field",
                {
                    headers: {
                        Authorization: token
                    }
                })
            .then(response => {
                resolve(response)
            }).catch(error => {
                verificationError(error);
                reject(error)
            })
    });
}

const findIdentificationOrIdOnly = (assistantId, isScreen = false, fieldSelected = null, novericationprint = false) => {
    return new Promise(async (resolve, reject) => {
        const db = await indexBD.getDb()
        const users = await indexBD.getUsers(db)
        const eventSelected = await indexBD.getEventSelecteds(db)
        let token = users[0].token;
        let event = eventSelected[0].event;
        let body = {};
        body.assistantId = assistantId;
        body.isScreen = isScreen;
        body.fieldSelected = fieldSelected;
        body.novericationprint = novericationprint;
        axios
            .post(urlServive + '/assistant/event/' + event._id + "/findidordocument/only",
                body,
                {
                    headers: {
                        Authorization: token
                    }
                })
            .then(response => {
                resolve(response)
            }).catch(error => {
                verificationError(error);
                reject(error)
            })
    });
}

const accessControl = (valueAssitant, zoneId, typeEnter, data) => {
    return new Promise(async (resolve, reject) => {
        const db = await indexBD.getDb()
        const users = await indexBD.getUsers(db)
        const eventSelected = await indexBD.getEventSelecteds(db)
        let token = users[0].token;
        let event = eventSelected[0].event;
        axios
            .post(urlServive + '/assist/save',
                {
                    eventId: event._id,
                    valueAssitant,
                    zone: zoneId,
                    typeEnter: typeEnter,
                    ...data
                },
                {
                    headers: {
                        Authorization: token
                    }
                })
            .then(response => {
                resolve(response)
            }).catch(error => {
                verificationError(error);
                reject(error)
            })
    })

}

const validFaceBacked = (file) => {
    return new Promise(async (resolve, reject) => {
        const db = await indexBD.getDb()
        const users = await indexBD.getUsers(db)
        const eventSelected = await indexBD.getEventSelecteds(db)
        let token = users[0].token;
        let event = eventSelected[0].event;
        const formData = new FormData();
        formData.append("file", file);

        axios
            .post(urlServive + `/assist/event/${event._id}/valid/face`,
                formData,
                {
                    headers: {
                        Authorization: token
                    }
                })
            .then(response => {
                resolve(response)
            }).catch(error => {
                verificationError(error);
                reject(error)
            })
    })

}


const validationfieldrequired = (data) => {
    return new Promise(async (resolve, reject) => {
        const db = await indexBD.getDb()
        const users = await indexBD.getUsers(db)
        const eventSelected = await indexBD.getEventSelecteds(db)
        let token = users[0].token;
        let event = eventSelected[0].event;
        axios
            .post(urlServive + '/assistant/event/' + event._id + '/validationfieldrequired',
                data,
                {
                    headers: {
                        Authorization: token
                    }
                })
            .then(response => {
                resolve(response)
            }).catch(error => {
                verificationError(error);
                reject(error)
            })
    })

}

const getInformationAssistant = (assistantId) => {
    return new Promise(async (resolve, reject) => {
        const db = await indexBD.getDb()
        const users = await indexBD.getUsers(db)
        let token = users[0].token;
        axios
            .get(urlServive + '/assistant/' + assistantId + '/information',
                {
                    headers: {
                        Authorization: token
                    }
                })
            .then(response => {
                resolve(response)
            }).catch(error => {
                verificationError(error);
                reject(error)
            })
    })
}

const printassistant = (data) => {
    return new Promise(async (resolve, reject) => {
        const db = await indexBD.getDb()
        const users = await indexBD.getUsers(db)
        const eventSelected = await indexBD.getEventSelecteds(db)
        let token = users[0].token;
        let event = eventSelected[0].event;

        let body = {};
        body.assistants = data;
        body.print = 'No selected';
        let configurationServer = localStorage.getItem("configurationServer");
        if (configurationServer) {
            let config = JSON.parse(configurationServer);
            if (config && config.print) {
                body.print = config.print;
            }
            body.urlPrint = (config.ip || 'https://aplicacionesincontacto.com:48080') + `/print`;
        } else {
            body.urlPrint = `https://aplicacionesincontacto.com:48080/print`;
        }
        axios
            .put(urlServive + '/assistant/event/' + event._id + '/printassistant',
                body,
                {
                    headers: {
                        Authorization: token
                    }
                })
            .then(response => {
                resolve(response)
            }).catch(error => {
                verificationError(error);
                reject(error)
            })
    })
}

const getPrints = (urlPrint) => {
    return new Promise(async (resolve, reject) => {
        axios
            .get(urlPrint + '/print/print/all')
            .then(response => {
                resolve(response)
            }).catch(error => {
                verificationError(error);
                reject(error)
            })
    })

}


const markCheckedAssistant = (data) => {
    return new Promise(async (resolve, reject) => {
        const db = await indexBD.getDb()
        const users = await indexBD.getUsers(db)
        const eventSelected = await indexBD.getEventSelecteds(db)
        let token = users[0].token;
        let event = eventSelected[0].event;
        axios
            .put(urlServive + '/assistant/event/' + event._id + '/markcheckedsssistant',
                data,
                {
                    headers: {
                        Authorization: token
                    }
                })
            .then(response => {
                resolve(response)
            }).catch(error => {
                verificationError(error);
                reject(error)
            })
    })
}

const allAssistantPagination = (value, page, size, conditional, groupInscription, suggested) => {
    return new Promise(async (resolve, reject) => {
        const db = await indexBD.getDb()
        const users = await indexBD.getUsers(db)
        const eventSelected = await indexBD.getEventSelecteds(db)
        let token = users[0].token;
        let event = eventSelected[0].event;
        axios
            .post(urlServive + '/assistant/all/' + event._id + '/pagination',
                {
                    value,
                    page,
                    size,
                    conditional,
                    groupInscription,
                    suggested
                },
                {
                    headers: {
                        Authorization: token
                    }
                })
            .then(response => {
                resolve(response)
            }).catch(error => {
                verificationError(error);
                reject(error)
            })
    })
}

const findAssistantByAccessControl = (valueAssitant, zone) => {
    return new Promise(async (resolve, reject) => {
        const db = await indexBD.getDb()
        const users = await indexBD.getUsers(db)
        const eventSelected = await indexBD.getEventSelecteds(db)
        let token = users[0].token;
        let event = eventSelected[0].event;
        axios
            .post(urlServive + '/assist/findassistant',
                {
                    eventId: event._id,
                    valueAssitant,
                    zone
                },
                {
                    headers: {
                        Authorization: token
                    }
                })
            .then(response => {
                resolve(response)
            }).catch(error => {
                verificationError(error);
                reject(error)
            })
    })
}

const validationfieldaccesscontrol = (data, zoneId) => {
    return new Promise(async (resolve, reject) => {
        const db = await indexBD.getDb()
        const users = await indexBD.getUsers(db)
        const eventSelected = await indexBD.getEventSelecteds(db)
        let token = users[0].token;
        let event = eventSelected[0].event;
        axios
            .post(urlServive + '/assistant/event/' + event._id + '/validationfieldaccesscontrol',
                {
                    ids: data,
                    zoneId: zoneId
                },
                {
                    headers: {
                        Authorization: token
                    }
                })
            .then(response => {
                resolve(response)
            }).catch(error => {
                verificationError(error);
                reject(error)
            })
    })
}

const saveAssistantRequired = (assistantId, body) => {
    return new Promise(async (resolve, reject) => {
        const db = await indexBD.getDb()
        const users = await indexBD.getUsers(db)
        const eventSelected = await indexBD.getEventSelecteds(db)
        let token = users[0].token;
        let event = eventSelected[0].event;
        axios
            .post(urlServive + '/assistant/' + assistantId + '/event/' + event._id + '/save/required',
                body
                ,
                {
                    headers: {
                        Authorization: token
                    }
                })
            .then(response => {
                resolve(response)
            }).catch(error => {
                verificationError(error);
                reject(error)
            })
    })
}

const fileAwsFace = (assistantId, data) => {
    return new Promise(async (resolve, reject) => {
        const formData = new FormData();
        formData.append("file", data);
        const db = await indexBD.getDb()
        const users = await indexBD.getUsers(db)
        const eventSelected = await indexBD.getEventSelecteds(db)
        let token = users[0].token;
        let event = eventSelected[0].event;
        axios
            .post(urlServive + `/aws_face/event/${event._id}/assistant/${assistantId}/valid`,
                formData
                ,
                {
                    headers: {
                        Authorization: token
                    }
                })
            .then(response => {
                resolve(response)
            }).catch(error => {
                verificationError(error);
                reject(error)
            })
    })
}


const fileAwsFacePublic = (data, eventId, assistantId) => {
    return new Promise(async (resolve, reject) => {
        const formData = new FormData();
        formData.append("file", data);
        const db = await indexBD.getDb()
        const users = await indexBD.getUsers(db)
        let token = users[0].token;
        axios
            .post(urlServive + `/aws_face/event/${eventId}/assistant/${assistantId}/validaut`,
                formData
                ,
                {
                    headers: {
                        Authorization: token
                    }
                })
            .then(response => {
                resolve(response.data)
            }).catch(error => {
                verificationError(error);
                reject(error)
            })
    })
}
const fileUploadOnlyService = (data, eventId) => {
    return new Promise(async (resolve, reject) => {
        const formData = new FormData();
        formData.append("file", data);
        const db = await indexBD.getDb()
        const users = await indexBD.getUsers(db)
        let token = users[0].token;
        axios
            .post(urlServive + `/file/upload/${eventId}/file/complete/only`,
                formData
                ,
                {
                    headers: {
                        Authorization: token
                    }
                })
            .then(response => {
                resolve(response.data)
            }).catch(error => {
                verificationError(error);
                reject(error)
            })
    });
}

const fileUploadOnly = (data, eventId) => {
    return new Promise((resolve, reject) => {
        fileUploadOnlyService(data, eventId)
            .then((resp) => {
                return resolve(resp.nameFile);
            }).catch(error => {
                reject(error);
            });
    })
}



const printService = (body) => {
    return new Promise(async (resolve, reject) => {
        let url = body.urlPrint;
        axios
            .post(url,
                body)
            .then(response => {
                resolve(response)
            }).catch(error => {
                verificationError(error);
                reject(error)
            })
    })

}

const getAllCountries = (eventId) => {
    return new Promise(async (resolve, reject) => {
        axios
            .get(urlServive + `/country/all`,
                {
                    headers: {
                        "eventId": eventId
                    }
                })
            .then(response => {
                resolve(response.data)
            }).catch(error => {
                verificationError(error);
                reject(error)
            })
    });
}

const getAllCity = (countryId, eventId) => {
    return new Promise(async (resolve, reject) => {
        axios
            .get(urlServive + `/country/${countryId}/all/city`,
                {
                    headers: {
                        "eventId": eventId
                    }
                })
            .then(response => {
                resolve(response.data)
            }).catch(error => {
                verificationError(error);
                reject(error)
            })
    });

}

const getAllDepartment = (countryId, eventId) => {
    return new Promise(async (resolve, reject) => {
        axios
            .get(urlServive + `/country/${countryId}/all/department`,
                {
                    headers: {
                        "eventId": eventId
                    }
                })
            .then(response => {
                resolve(response.data)
            }).catch(error => {
                verificationError(error);
                reject(error)
            })
    });

}


const getAllCityByDepartment = (departmentId, eventId) => {
    return new Promise(async (resolve, reject) => {
        axios
            .get(urlServive + `/country/${departmentId}/all/departmentCity`,
                {
                    headers: {
                        "eventId": eventId
                    }
                })
            .then(response => {
                resolve(response.data)
            }).catch(error => {
                verificationError(error);
                reject(error)
            })
    });
}

const getIndicatevesCellPhone = () => {
    return new Promise(async (resolve, reject) => {
        axios
            .get(urlServive + `/indicativecellphone/all`)
            .then(response => {
                resolve(response.data)
            }).catch(error => {
                verificationError(error);
                reject(error)
            })
    });
}
const verificationPassword = (password, type) => {
    return new Promise(async (resolve, reject) => {
        axios
            .post(urlServive + `/global_password/${type}/verification`, {
                password: password
            })
            .then(response => {
                resolve(response.data)
            }).catch(error => {
                verificationError(error);
                reject(error)
            })
    });
}

const sendWhatapp = (assistantId, eventId, typeView = 1) => {
    return new Promise(async (resolve, reject) => {
        const db = await indexBD.getDb()
        const users = await indexBD.getUsers(db)
        const token = users[0].token;

        axios
            .get(urlServive + `/assistant/event/${eventId}/assistant/${assistantId}/resend/whatapps?typeView=${typeView}`,
                {
                    headers: {
                        Authorization: token
                    }
                }
            )
            .then(response => {
                resolve(response.data)
            }).catch(error => {
                verificationError(error);
                reject(error)
            })
    });
}

const sendEMAILPublic = (assistantId, eventId, typeView= 1) => {
    return new Promise(async (resolve, reject) => {
        const db = await indexBD.getDb()
        const users = await indexBD.getUsers(db)
        const token = users[0].token;
        axios
            .get(urlServive + `/assistant/event/${eventId}/assistant/${assistantId}/send/email/public/inscription?typeView=${typeView}`,
                {
                    headers: {
                        Authorization: token
                    }
                }
            )
            .then(response => {
                resolve(response.data)
            }).catch(error => {
                verificationError(error);
                reject(error)
            })
    });
}

const updateInputValueOneAssistant = (eventId, assistantId, fieldId, value) => {
    return new Promise(async (resolve, reject) => {
        const db = await indexBD.getDb()
        const users = await indexBD.getUsers(db)
        const token = users[0].token;
        axios
            .post(urlServive + `/assistant/${assistantId}/event/${eventId}/field/${fieldId}/updateoneproperty`,
                {
                    value: value
                },
                {
                    headers: {
                        Authorization: token
                    }
                }
            )
            .then(response => {
                resolve(response.data)
            }).catch(error => {
                verificationError(error);
                reject(error)
            })
    });
}


const findExhibitorPagination = (value) => {
    return new Promise(async (resolve, reject) => {
        const db = await indexBD.getDb()
        const users = await indexBD.getUsers(db)
        const eventSelected = await indexBD.getEventSelecteds(db)
        let token = users[0].token;
        let event = eventSelected[0].event;
        let body = {};
        body.value = value;
        axios
            .post(urlServive + `/exhibitor/event/${event._id}/pagination/exhibitor/appregistros`,
                body,
                {
                    headers: {
                        Authorization: token
                    }
                })
            .then(response => {
                resolve(response)
            }).catch(error => {
                verificationError(error);
                reject(error)
            })
    });
}

const getViewStatisticOnly = (userId) => {
    return new Promise(async (resolve, reject) => {
        const db = await indexBD.getDb()
        const users = await indexBD.getUsers(db)
        const eventSelected = await indexBD.getEventSelecteds(db)
        let token = users[0].token;
        let event = eventSelected[0].event;
        axios
            .get(urlServive + `/exhibitor/event/${event._id}/user/${userId}/statistic`,
                {
                    headers: {
                        Authorization: token
                    }
                })
            .then(response => {
                resolve(response)
            }).catch(error => {
                verificationError(error);
                reject(error)
            })
    });
}

const getAllCodeInformationExhibitor = (userId) => {
    return new Promise(async (resolve, reject) => {
        const db = await indexBD.getDb()
        const users = await indexBD.getUsers(db)
        const eventSelected = await indexBD.getEventSelecteds(db)
        let token = users[0].token;
        let event = eventSelected[0].event;
        axios
            .get(urlServive + `/code_exhibitor/${userId}/event/${event._id}/all`,
                {
                    headers: {
                        Authorization: token
                    }
                })
            .then(response => {
                resolve(response)
            }).catch(error => {
                verificationError(error);
                reject(error)
            })
    });
}



const saveUserExhibitorAssigmentEventCodeRegister = (userId, codeCompleteSave) => {
    return new Promise(async (resolve, reject) => {
        const db = await indexBD.getDb()
        const users = await indexBD.getUsers(db)
        const eventSelected = await indexBD.getEventSelecteds(db)
        let token = users[0].token;
        let event = eventSelected[0].event;
        axios
            .post(urlServive + `/code_exhibitor/${userId}/event/${event._id}/save`, codeCompleteSave,
                {
                    headers: {
                        Authorization: token
                    }
                })
            .then(response => {
                resolve(response)
            }).catch(error => {
                verificationError(error);
                reject(error)
            })
    });
}


const sendEmailCodeRegisterExhibitor = (codeId, type) => {
    return new Promise(async (resolve, reject) => {
        const db = await indexBD.getDb()
        const users = await indexBD.getUsers(db)
        const eventSelected = await indexBD.getEventSelecteds(db)
        let token = users[0].token;
        let event = eventSelected[0].event;
        axios
            .get(urlServive + `/code_exhibitor/${codeId}/event/${event._id}/type/${type}/send`,
                {
                    headers: {
                        Authorization: token
                    }
                })
            .then(response => {
                resolve(response)
            }).catch(error => {
                verificationError(error);
                reject(error)
            })
    });
}

const autoCompletedSearchIA = (value, fields) => {
    return new Promise(async (resolve, reject) => {
        const db = await indexBD.getDb()
        const users = await indexBD.getUsers(db);
        const eventSelected = await indexBD.getEventSelecteds(db)
        let token = users[0].token;
        let event = eventSelected[0].event;
        axios
            .post(urlServive + `/assistant/event/fields/assistant/autocompletaria`,
                {
                    eventId: event._id,
                    value,
                    fields,
                    ticket: false
                },
                {
                    headers: {
                        Authorization: token
                    }
                })
            .then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
    });
}

const validToken = () => {
    return new Promise(async (resolve) => {
        let next = true;
        const db = await indexBD.getDb();
        const users = await indexBD.getUsers(db);
        if (!users) {
            next = false;
        }
        if (users && users.length <= 0) {
            next = false;
        }
        return resolve(next);
    });
}

const verificationError = async (error) => {
    console.log(error);
    if (error.response && error.response.status == 401) {
        let db = await indexBD.getDb();
        await indexBD.closeSession(db);
        clearInterval(timerS)
        $router.push("/login");
    }
}


export default {
    login,
    getEvents,
    syncPerson,
    reportError,
    getSystemOperativo,
    getBrowser,
    getUserEvents,
    closeAllSessionNotEvent,
    getAvaliablesZones,
    accessControl,
    getScreen,
    allFieldsPublic,
    findIdentificationOrIdOnly,
    getPrints,
    validationfieldrequired,
    getInformationAssistant,
    printassistant,
    markCheckedAssistant,
    printService,
    allAssistantPagination,
    findAssistantByAccessControl,
    validationfieldaccesscontrol,
    saveAssistantRequired,
    getInformationEvent,
    allFields,
    fileAwsFace,
    diff_to_GMT,
    fileAwsFacePublic,
    fileUploadOnly,
    getAllCountries,
    getAllCity,
    getAllDepartment,
    getAllCityByDepartment,
    getIndicatevesCellPhone,
    verificationPassword,
    validFaceBacked,
    sendWhatapp,
    sendEMAILPublic,
    updateInputValueOneAssistant,
    findExhibitorPagination,
    getViewStatisticOnly,
    getAllCodeInformationExhibitor,
    saveUserExhibitorAssigmentEventCodeRegister,
    sendEmailCodeRegisterExhibitor,
    autoCompletedSearchIA,
    signatureOnly
}